import { render, staticRenderFns } from "./Transports.vue?vue&type=template&id=04eae60d&scoped=true"
import script from "./Transports.vue?vue&type=script&lang=js"
export * from "./Transports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eae60d",
  null
  
)

export default component.exports